<template>
  <div class="page">
    <Header
        :title=pageTitle
    />
    <div class="container dashboard card">
      <div class="card-body">
        <div class="container dashboard page-content fadeIn index no-center">
          <form class="form-horizontal">
            <div class="form-group">
              <div class="col-sm-10">
                <p class="help-text m-0"><i class="fa fa-info-circle"></i>
                  <span v-text="'Datacenter'"/>
                </p>
                <v-select
                    :options="DcList"
                    label="label"
                    v-model="formData.DcId"
                    :reduce="server => server.value"
                    placeholder="Select Datacenter.."
                    required
                    inputId="Type"/>
              </div>
            </div>

            <div class="form-group">
              <div class="col-sm-10">
                <p class="help-text m-0"><i class="fa fa-info-circle"></i>
                  <span v-text="'[hostname] <ip> <netmask> <gateway> [MAC-Addr]'"/>
                </p>
                <prism-editor
                    class="editor min-height-300"
                    v-model="formData.Import"
                    :highlight="highlighter"
                    line-numbers
                    id="ip-import-area"
                />
                <!--                <b-form-textarea-->
                <!--                    class="form-control"-->
                <!--                    required-->
                <!--                    placeholder="N/A"-->
                <!--                    v-model="formData.Import"></b-form-textarea>-->
              </div>
            </div>
          </form>
          <div class="modal-footer">
            <button @click="submitForm()" class="btn btn-primary">Create</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import {TokenMixin} from '@/assets/js/mixins/token-mixin';
import Header from './Header.vue';
import {ErrorsMixin} from "@/assets/js/mixins/errors-mixin";
import _ from "lodash";
//import {EventBus} from "@/eventBus";
import {PrismEditor} from "vue-prism-editor";

export default {
  name: 'IpImportPage',
  mixins: [
    TokenMixin,
    ErrorsMixin,
  ],
  components: {
    PrismEditor,
    Header
  },
  data() {
    return {
      loadDCsUrl: '/api/manager/dc/list?sort=Id',
      apiUrl: '/api/manager/ip/',
      DcList: [],
      formData: {
        DcId: null,
        Import: null
      },
      initScrollLimit: 100,
      pageId: null,
      pageTitle: 'Ip import',
      title: 'Ip import',
      error: '',
      loaded: false,
    };
  },
  methods: {
    submitForm() {
      let loader = this.$loading.show();
      axios.post(this.apiUrl, {...this.formData}, this.authRespConf())
          .then((res) => {
            loader.hide();
            this.$bvToast.toast(res.data.message, {
              title: `Successfully request`,
              noAutoHide: true,
              variant: 'success',
              appendToast: true
            })
            //this.modalClosed()
          })
          .catch((err) => {
            loader.hide();
            this.errorHandle(err, true, true);
          });
    },
    highlighter(code) {
      const formats = [
        /^(\S+)\s+(\d{1,3}(?:\.\d{1,3}){3})\s+(\d{1,3}(?:\.\d{1,3}){3})\s+(\d{1,3}(?:\.\d{1,3}){3})\s+([0-9A-Fa-f]{2}(?::[0-9A-Fa-f]{2}){5})$/,
        /^(\S+)\s+(\d{1,3}(?:\.\d{1,3}){3})\s+(\d{1,3}(?:\.\d{1,3}){3})\s+(\d{1,3}(?:\.\d{1,3}){3})$/,
        /^(\d{1,3}(?:\.\d{1,3}){3})\s+(\d{1,3}(?:\.\d{1,3}){3})\s+(\d{1,3}(?:\.\d{1,3}){3})\s+([0-9A-Fa-f]{2}(?::[0-9A-Fa-f]{2}){5})$/,
        /^(\d{1,3}(?:\.\d{1,3}){3})\s+(\d{1,3}(?:\.\d{1,3}){3})\s+(\d{1,3}(?:\.\d{1,3}){3})$/,
        /^(\S+)\s+(\d{1,3}(?:\.\d{1,3}){3})$/,
        /^(\d{1,3}(?:\.\d{1,3}){3})$/,
      ];

      const lines = code.split('\n');
      return lines.map(line => {
        let matched = false;
        for (let format of formats) {
          if (format.test(line)) {
            matched = true;
            break;
          }
        }
        if (matched) {
          return `<span class="correct-format">${line}</span>`;
        } else {
          return `<span class="incorrect-format">${line}</span>`;
        }
      }).join('\n');
    },
    highlightFormat() {
      // This method can be used for additional processing if needed
    },
    getDcList() {
      let loader = this.$loading.show();
      axios.post(this.loadDCsUrl, [], this.authRespConf())
          .catch((err) => {
            loader.hide();
            this.loading = 'loaded';
            this.moveUp();
            this.errorHandle(err, true, true);
          })
          .then(res => {
            loader.hide();
            this.loading = 'loaded';
            if (res.data.data !== undefined) {
              this.DcList = _.map(res.data.data, (item) => {
                return {
                  label: item.Name,
                  value: item.Id
                }
              })
            }
          })
    },
  },
  mounted() {
    this.getDcList();
  },
  created() {
    //EventBus.$on("IpImportModalOpen", this.initScrolls);
  },
  beforeDestroy() {
    //EventBus.$off("IpImportModalOpen", this.initScrolls);
  },
}
</script>

<style scoped>
.center {
  vertical-align: middle;
  text-align: center;
}

.edit-area {
  width: 100%;
  height: 300px;
}

.container.dashboard {
  width: 100%;
  margin: 0 0 0 1.5rem;
}
.file-form-add, #file-form {
  margin: 10px 0 10px 0;
}
.file-forms-container {
  float: left;
}

.min-height-300 {
  min-height: 10rem;
}
pre span.incorrect-format:empty:after {
  content: 'Not assigned';
}
</style>
